export { default as StockStatus } from './stock-status'
